import axios from 'axios';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getNewsSlice = createSlice({
    name: 'news',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchNews.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchNews.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchNews.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    },
});

export const { setNews, setStatus } = getNewsSlice.actions;
export default getNewsSlice.reducer;

export const fetchNews = createAsyncThunk('newsGet/fetch', async ({ SearchTitle, currentPage }) => {
    const res = await axios.get(`${window.env.API_URL}/newsget?TitleEn=${SearchTitle}&page=${currentPage}`)
    const data = res.data;
    return data.data;
});


